import { BreadcrumbItem } from '../components/Breadcrumb'

// Route mapping for breadcrumb generation
const routeLabels: Record<string, string> = {
  // Main sections
  '/start': 'Start Here',
  '/personal': 'Personal Protocol',
  '/organization': 'Organizational Security Protocol',
  '/tools': 'Tools Library',
  '/compliance': 'Compliance',
  '/risk-assessment': 'Risk Assessment',
  '/about': 'About',

  // Organization sub-pages
  '/organization/govern': 'Governance & Leadership',
  '/organization/governance': 'Governance & Leadership',
  '/organization/identify': 'Assets & Risk Awareness',
  '/organization/protect': 'Protection & Prevention',
  '/organization/detect': 'Detection & Monitoring',
  '/organization/respond': 'Incident Response',
  '/organization/recover': 'Recovery & Improvement',

  // Personal sub-pages
  '/personal/identity': 'Identity',
  '/personal/communication': 'Communication',
  '/personal/data-backup': 'Data & Backup',
  '/personal/internet': 'Internet Safety',
  '/personal/incident-response': 'Incident Response',

  // Device pages
  '/devices': 'Devices',
  '/devices/ios': 'iOS Security',
  '/devices/android': 'Android Security',
  '/devices/windows': 'Windows Security',
  '/devices/macos': 'macOS Security',
  '/devices/linux': 'Linux Security',

  // Incident Response
  '/ir': 'Incident Response',
  '/ir/account-takeover': 'Account Takeover',
  '/ir/lost-device': 'Lost Device',

  // Tools
  '/tools/breach-check': 'Breach Check',
  '/tools/password-safety': 'Password Safety',
  '/tools/mfa-passkeys': 'MFA & Passkeys',
  '/tools/privacy': 'Privacy Tools',
  '/tools/backup': 'Backup Tools',
  '/tools/business-security': 'Business Security',

  // Compliance - ONLY Global and Indonesia
  '/compliance/global': 'Global Standards',
  '/compliance/indonesia': 'Indonesia (UU PDP)',

  // About
  '/about/mission': 'Mission',
  '/about/scope': 'Scope',
  '/about/standards': 'Standards & Methodology',
  '/about/changelog': 'Changelog',
  '/about/governance': 'Governance',
  '/about/disclaimer': 'Disclaimer',
  '/about/contact': 'Contact',
}

/**
 * Auto-generate breadcrumbs based on current pathname
 */
export function generateBreadcrumbs(pathname: string): BreadcrumbItem[] {
  // Homepage has no breadcrumbs
  if (pathname === '/') {
    return []
  }

  const breadcrumbs: BreadcrumbItem[] = []
  const pathSegments = pathname.split('/').filter(Boolean)

  let currentPath = ''

  for (let i = 0; i < pathSegments.length; i++) {
    currentPath += `/${pathSegments[i]}`
    const label = routeLabels[currentPath] || formatSegment(pathSegments[i])

    // Last item should not have a path (current page)
    if (i === pathSegments.length - 1) {
      breadcrumbs.push({ label })
    } else {
      breadcrumbs.push({ label, path: currentPath })
    }
  }

  return breadcrumbs
}

/**
 * Format URL segment into readable label
 */
function formatSegment(segment: string): string {
  return segment
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

/**
 * Get parent path for back navigation
 */
export function getParentPath(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean)

  if (segments.length <= 1) {
    return '/'
  }

  // Remove last segment to get parent
  segments.pop()
  return '/' + segments.join('/')
}

/**
 * Get parent label for back button
 */
export function getParentLabel(pathname: string): string {
  const parentPath = getParentPath(pathname)

  if (parentPath === '/') {
    return 'Home'
  }

  return (
    routeLabels[parentPath] || formatSegment(parentPath.split('/').pop() || '')
  )
}
